export enum VideoType {
  LIVE = "application/x-mpegurl",
  VOD = "video/mp4",
}

export const getVideoType = (source: string): string | null => {
  const videoFileExtension = source?.split(".").pop();

  if (!videoFileExtension) {
    return null;
  }

  switch (videoFileExtension) {
    case "m3u8":
      return VideoType.LIVE;
    case "mp4":
    default:
      return VideoType.VOD;
  }
};
